import React from 'react'
import Link from 'gatsby-link'
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  EmailShareButton,
} from 'react-share';

//  Components
import iconEmailUrl, { ReactComponent as IconEmail } from '../../assets/svg/icon-email.svg'
import iconTwitterUrl, { ReactComponent as IconTwitter } from '../../assets/svg/icon-twitter.svg'
import iconFacebookUrl, { ReactComponent as IconFacebook } from '../../assets/svg/icon-facebook.svg'
import iconLinkedInUrl, { ReactComponent as IconLinkedIn } from '../../assets/svg/icon-linkedin.svg'

//  Styles
import styles from './ShareExhibit.module.scss'

class ShareExhibit extends React.Component {
  render() {

    const { exhibit, social, site } = this.props;

    let sharePath = site.siteUrl;
    let shareTitle = site.title;
    let shareDescription = site.siteDescription;
    let emailTitle = site.title;

    let prefix = site.siteUrl;
    if(site.siteUrl === "/") {
      prefix = "";
    }

    const currentNode = social.filter(node => node.node.exhibit.includes(exhibit) )[0];

    if(currentNode !== undefined) {
      let node = currentNode.node;

      sharePath = prefix + node.path;
      if(node.path[0] !== "/") {
        sharePath = node.path;
      }

      if(node.share_path.length > 0) {
        sharePath = node.share_path;
      }

      if(node.title.length > 0) {
        shareTitle = `${node.title}\n${shareTitle}`;
      }
    }

    return (
      <div className={ styles.share_exhibit }>
        <h2 className={ styles.share_title }>Share</h2>
        <ul className={ styles.share_list }>
          <li>
            <EmailShareButton subject={ emailTitle } body={ `${shareTitle}\n\n${shareDescription}\n\n${sharePath}` } quote={ shareTitle } url={ sharePath } className={ styles.share_list_icon }>
              <IconEmail />
            </EmailShareButton>
          </li>
          <li>
            <TwitterShareButton via="commonwealthfnd" quote={ shareTitle } title={ shareTitle } url={ sharePath } className={ styles.share_list_icon }>
              <IconTwitter />
            </TwitterShareButton>
          </li>
          <li>
            <FacebookShareButton quote={ shareTitle } url={ sharePath } className={ styles.share_list_icon }>
              <IconFacebook />
            </FacebookShareButton>
          </li>
          <li>
            <LinkedinShareButton title={ shareTitle } description={ shareDescription } quote={ shareTitle } url={ sharePath } className={ styles.share_list_icon }>
              <IconLinkedIn />
            </LinkedinShareButton>
          </li>
        </ul>
      </div>
    )
  }
}

export default ShareExhibit



// WEBPACK FOOTER //
// ./src/components/ShareExhibit/ShareExhibit.js